import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02352450"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-container h-full" }
const _hoisted_2 = { class: "flex flex-row flex-wrap h-full" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row basis-full lg:basis-6/12\" data-v-02352450><ul class=\"text-[13px] sm:text-sm basis-4/12 pl-6 sm:pl-0 footer-menu cursor-pointer\" data-v-02352450><li data-v-02352450><a href=\"/\" data-v-02352450>HOME</a></li><li class=\"hidden\" data-v-02352450><a href=\"\" data-v-02352450>品牌介紹</a></li><li data-v-02352450><a href=\"/user/contact\" data-v-02352450>聯絡我們</a></li></ul><ul class=\"text-[13px] sm:text-sm basis-4/12 pl-0 sm:pl-0 footer-menu cursor-pointer\" data-v-02352450><li data-v-02352450><a href=\"/\" data-v-02352450>CUSTOMER SERVICE</a></li><li data-v-02352450><a class=\"tracking-widest\" href=\"tel:04-36081958\" data-v-02352450>04 - 36081958</a></li><li style=\"margin-bottom:2rem;\" class=\"mb-6 tracking-widest\" data-v-02352450><a href=\"/user/contact\" data-v-02352450>service@horlay.com</a></li></ul></div>", 1)
const _hoisted_4 = { class: "hidden sm:flex flex-col basis-full lg:basis-6/12 items-end" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-logo" }, null, -1))
const _hoisted_6 = { class: "footer-social-media-icons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "footer-policy" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "/faq?Id=4" }, "隱私權政策")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "/faq?Id=3" }, "網站使用條款")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "© 2022 HORLaY All Rights Reserved.")
], -1))
const _hoisted_8 = { class: "sm:hidden flex flex-col w-full" }
const _hoisted_9 = { class: "flex gap-2 mx-auto" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col mt-6 w-full items-center\" data-v-02352450><div class=\"text-xs tracking-[.12em]\" data-v-02352450> © 2022 HORLaY All Rights Reserved. </div><div class=\"mt-3 flex gap-6\" data-v-02352450><a class=\"text-xs\" href=\"/faq?Id=4\" data-v-02352450>隱私權政策</a><a class=\"text-xs\" href=\"/faq?Id=3\" data-v-02352450>網站使用條款</a></div><div data-v-02352450></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Spacer),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "facebook",
                class: "cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage('facebook'))),
                width: "29px"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "instagram",
                class: "cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage('instagram'))),
                width: "29px"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "line",
                class: "cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage('line'))),
                width: "29px"
              })
            ])
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "facebook",
                class: "cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('facebook'))),
                width: "29px"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "instagram",
                class: "cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('instagram'))),
                width: "29px"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_Icon, {
                iconName: "line",
                class: "cursor-pointer",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage('line'))),
                width: "29px"
              })
            ])
          ]),
          _hoisted_10
        ])
      ])
    ])
  ]))
}